import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  IconButton,
  Icon,
  Popover,
  MenuItem,
  Divider,
  Typography,
  Link,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../../store/ducks/userProfile';
import HelpPageModal from './HelpPageModal';
import useStyles from './styles';

const HelpMenu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    product: {
      helpLink,
      helpTitle,
      supportEmail,
      helpInNewTab,
      showWelcomeMessage,
    },
    userProfile: { firstAccess },
  } = useSelector(state => state);
  const [showHelpMenu, setShowHelpMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [helpPageModalOpen, setHelpPageModalOpen] = useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleOpenHelp = useCallback(() => {
    if (helpInNewTab) {
      window.open(helpLink, '_newtab');
    } else {
      setHelpPageModalOpen(true);
    }
    handleClose();
  }, [handleClose, helpInNewTab, helpLink]);

  const handleCloseHelpPageModal = useCallback(() => {
    setHelpPageModalOpen(false);
  }, []);

  const handleOpenWelcome = useCallback(() => {
    dispatch(Actions.forceOpenWelcomeModal());
    handleClose();
  }, [dispatch, handleClose]);

  useEffect(() => {
    setShowHelpMenu(
      !!helpLink ||
        supportEmail ||
        (firstAccess?.htmlMessage && showWelcomeMessage),
    );
  }, [
    helpLink,
    helpTitle,
    supportEmail,
    helpInNewTab,
    firstAccess?.htmlMessage,
    showWelcomeMessage,
  ]);

  return (
    showHelpMenu && (
      <>
        <IconButton className="icon-toolbar" size="small" onClick={handleClick}>
          <Icon>help_outline</Icon>
        </IconButton>
        <Popover
          className={classes.container}
          id="help-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {supportEmail && (
            <>
              <Box className="help-email-container">
                <Typography className="help-email-label" variant="overline">
                  E-mail para ajuda:
                </Typography>
                <Link
                  className="help-email-link"
                  href={`mailto:${supportEmail}`}
                >
                  <Typography className="help-email-text" variant="body2">
                    {supportEmail}
                  </Typography>
                </Link>
              </Box>
              <Divider />
            </>
          )}
          {!!firstAccess?.htmlMessage && showWelcomeMessage && (
            <MenuItem
              onClick={handleOpenWelcome}
              classes={{ root: classes.menuItem }}
            >
              <Typography className="help-menu-item-text" variant="body2">
                Introdução
              </Typography>
            </MenuItem>
          )}
          {!!helpLink && (
            <MenuItem
              onClick={handleOpenHelp}
              classes={{ root: classes.menuItem }}
            >
              <Typography className="help-menu-item-text" variant="body2">
                {helpTitle || 'Suporte'}
              </Typography>
              <Icon className="help-menu-item-icon" fontSize="small">
                launch
              </Icon>
            </MenuItem>
          )}
          {helpPageModalOpen && (
            <HelpPageModal
              onClose={handleCloseHelpPageModal}
              helpLink={helpLink}
            />
          )}
        </Popover>
      </>
    )
  );
};

export default HelpMenu;
